import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION14: PdfComponent = {
  type: 'section',
  id: 's14',
  title: '14. Termination',
  content: [
    {
      type: 'bulletList',
      id: 's14bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'In accordance with clause 2 (Consideration, Commencement and Term), following the conclusion of the Initial Term, this Agreement may be terminated by:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: "the Subscriber by giving Kanda no less than thirty (30) days' notice in writing prior to the expiry of the Extension Period; or",
              },
              {
                copy: "Kanda by giving no less than one (1) month's notice in writing at any time.",
              },
            ],
          },
        },
        {
          copy: 'Either party may terminate this Agreement at any time by giving notice in writing to the other party if that other party:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'commits a Material Breach of this Agreement and such breach is not remediable;',
              },
              {
                copy: 'commits a Material Breach of this Agreement and that breach is not remedied within 14 days of receiving written notice of such breach;',
              },
              {
                copy: 'stops carrying on all or a significant part of its business, or indicates in any way that it intends to do so;',
              },
              {
                copy: 'is unable to pay its debts either within the meaning of section 123 of the Insolvency Act 1986 or if the non-defaulting party reasonably believes that to be the case;',
              },
              {
                copy: 'becomes the subject of a company voluntary arrangement under the Insolvency Act 1986;',
              },
              {
                copy: 'has a receiver, manager, administrator or administrative receiver appointed over all or any part of its undertaking, assets or income;',
              },
              {
                copy: 'has a resolution passed for its winding up;',
              },
              {
                copy: 'has a petition presented to any court for its winding up or an application is made for an administration order, or any winding-up or administration order is made against it;',
              },
              {
                copy: 'is subject to any procedure for the taking control of its goods that is not withdrawn or discharged within seven (7) days of that procedure being commenced;',
              },
              {
                copy: 'has a freezing order made against it;',
              },
              {
                copy: 'is subject to any recovery or attempted recovery of items supplied to it by a supplier retaining title to those items;',
              },
              {
                copy: 'is subject to any events or circumstances analogous to those in clauses 14.2(c) to 14.2(k) in any jurisdiction;',
              },
              {
                copy: 'is in breach of clause 15 (Confidential Information), clause 18 (Data Protection and Security) and/or clause 19 (Intellectual Property Rights); or',
              },
              {
                copy: 'has any consent, licence, permission or authorisation revoked or modified such that it is no longer able to comply with its obligations under this Agreement or receive any benefit to which it is entitled.',
              },
            ],
          },
        },
        {
          copy: "Kanda may terminate this Agreement if a lender within Kanda's panel refuses to provide Credit Facilities to the Subscriber, and such refusal is based on Completed Loans showing a credit score or credit performance that is Materially Worse (as assessed at any time) than was expected prior to the commencement of this Agreement. For the purposes of this clause 14.3, Materially Worse means:",
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'in relation to credit score, where the average credit score for all Customers that have applied for a credit product via Kanda in the immediately preceding ninety (90) calendar days is equal to or less than:',
                sublist: {
                  bulletType: 'roman',
                  content: [
                    {
                      copy: 'Delphi score: 800',
                    },
                    {
                      copy: 'TransUnion / CallCredit score: 550, as applicable; and',
                    },
                  ],
                },
              },
              {
                copy: 'in relation to credit performance, where the quotient of the following equation, expressed as a percentage, is equal to or greater than 5%:',
                sublist: {
                  bulletType: 'blank',
                  content: [
                    {
                      copy: 'A/B',
                    },
                    {
                      copy: 'Where:',
                    },
                    {
                      copy: 'A = the aggregate loan principal value of all Completed Loans that fall within B that are or have ever been at least one month in arrears; and',
                    },
                    {
                      copy: 'B = the aggregate loan principal value of all Completed Loans (excluding any loan principal value of any Cancelled Loans and Exceptions) originated in the immediately preceding 90 calendar days.',
                    },
                  ],
                },
              },
            ],
          },
        },
        {
          copy: "Kanda may terminate this Agreement at any time by giving not less than 21 days' notice in writing to the Subscriber if the Subscriber undergoes a change of Control whereby Control subsequently vests with a direct competitor of Kanda or with a person who, in the reasonable opinion of Kanda, has unacceptable business ethics or practices.",
        },
        {
          copy: 'The right of a party to terminate the Agreement pursuant to clauses 14.2(c) to 14.2(k) (inclusive) shall not apply to the extent that the relevant procedure is entered into for the purpose of amalgamation, reconstruction or merger (where applicable) where the amalgamated, reconstructed or merged party agrees to adhere to this Agreement.',
        },
        {
          copy: 'Termination or expiry of this Agreement shall not affect any accrued rights and liabilities of either party at any time up to the date of termination.',
        },
        {
          copy: 'The provisions of clauses 1, 9, 10, 11, 12, 13, 16.8, 17, 18, 19, 21 to 42 (inclusive), and any other provision of this Agreement which expressly or by implication is intended to come into or continue in force on or after the expiry or termination of this Agreement, shall remain in full force and effect after this Agreement expires or terminates.',
        },
        {
          copy: 'Other than as referred to in this clause 14 (Termination), neither party shall have any further obligation to the other party under this Agreement on or after its expiry or termination.',
        },
      ],
      prefix: '14',
    },
  ],
};
